export default "__VITE_ASSET__4fc57aed__"